import { Component, EventEmitter, Input, input, Output } from '@angular/core';
import { COMMON_IMPORTS } from '../common-imports';

export interface PatientInfo {
  name: string;
  todaysDate: string;
  ageAtVisit: number;
}

@Component({
  selector: 'app-patient-info-input',
  standalone: true,
  imports: [...COMMON_IMPORTS],
  templateUrl: './patient-info-input.component.html',
  styleUrl: './patient-info-input.component.css',
})
export class PatientInfoInputComponent {
  @Input()
  name: string = '';
  @Input()
  todaysDate: string = new Date().toISOString().split('T')[0];
  @Input()
  ageAtVisit: number | null | undefined = null;
  @Input()
  title: string = 'PreMO';
  @Input()
  dateOfLastVisit?: Date;

  onNameChange(value: string): void {
    this.name = value;
  }

  onDateChange(value: string): void {
    this.todaysDate = value;
  }

  onAgeChange(value: string): void {
    this.ageAtVisit = value ? Number(value) : null;
  }
}
